import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { NotificationSettings } from "@/components/NotificationSettings";
import { useAuth } from "@/contexts/AuthContext";

const Notifications = () => {
  const navigate = useNavigate();
  const { establishmentId } = useAuth();

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="bg-card border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={() => navigate('/dashboard')}>
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <h1 className="text-xl md:text-2xl font-serif font-bold">
              Paramètres de notifications
            </h1>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-6 max-w-2xl">
        <NotificationSettings establishmentId={establishmentId || undefined} />
      </div>
    </div>
  );
};

export default Notifications;
